export function getReturnArrangementLabel(booking = {}) {
  const type = String(booking.returnArrangementType || "").trim();
  const address = String(booking.returnPickupAddress || "").trim();

  if (type === "return_to_office") {
    return "Customer will return the vehicle to FleetX office/garage.";
  }
  if (type === "pickup_same_location") {
    return "FleetX pickup from same delivery location.";
  }
  if (type === "pickup_different_location") {
    return address
      ? `FleetX pickup from different location: ${address}`
      : "FleetX pickup from different location.";
  }
  return "Return arrangement not specified.";
}

export function getReturnPickupFeeStatusLabel(booking = {}) {
  return String(booking.returnPickupFeeStatus || "").trim() === "to_be_confirmed"
    ? "Return pickup fee to be confirmed by FleetX."
    : "";
}
